import { createI18n } from 'vue-i18n';
import zhTW from './zh_TW';
import enUS from './en_US';
import zhCN from './zh_CN';
import jaJP from './ja_JP';
import thTH from './th_TH';
import esES from './es_ES';
import idID from './id_ID';
import { getCookie } from '@/utils/cookie';
import { engageLabCore } from '@jg/qiankun-micro-tool';

export default createI18n({
  locale: engageLabCore.locale.takeImmediately(),
  allowComposition: true,
  messages: {
    en_US: enUS,
    zh_TW: zhTW,
    zh_CN: zhCN,
    ja_JP: jaJP,
    th_TH: thTH,
    es_ES: esES,
    id_ID: idID,
  },
  fallbackLocale: 'en_US',
});
